module.exports = __webpack_public_path__ + "img/cloud-food.68324087.svg";